import React, { lazy, Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import { ClerkProvider } from '@clerk/clerk-react';
import { Analytics } from '@vercel/analytics/react';
import { SpeedInsights } from '@vercel/speed-insights/react';
import { PayPalScriptProvider, ReactPayPalScriptOptions } from '@paypal/react-paypal-js';
import * as Sentry from '@sentry/react';
import 'normalize.css';

Sentry.init({
  dsn: 'https://dd34a5f5a31147dffff5fe9b65afb6f0@o4509213616439296.ingest.us.sentry.io/4509213618274304',
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true,
});

const ClerkPk = S_Clerk_pk;
const PayPalClientId = S_PayPal_clientId;

// 允许 PayPal 和 信用卡两种支付方式
const initialOptions: ReactPayPalScriptOptions = {
  clientId: PayPalClientId,
  disableFunding: ['venmo', 'paylater'],
  environment: PayPalClientId === 'sb' ? 'sandbox' : 'production',
};

const RenderRouter = lazy(() => import('./routes'));

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <SpeedInsights />
    <Analytics />
    <ClerkProvider publishableKey={ClerkPk} afterSignOutUrl="/">
      <PayPalScriptProvider options={initialOptions}>
        <Suspense>
          <RenderRouter />
        </Suspense>
      </PayPalScriptProvider>
    </ClerkProvider>
  </React.StrictMode>,
);
